import Rotas from "./services/rotas";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className="App">
      <ToastContainer autoClose={1000}/>
      <Rotas />
    </div>
  );
}

export default App;
